"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapMediaInfoToLiveVideoStatus = void 0;
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var live_statuses_1 = require("@wix/wix-vod-constants/dist/common/live-statuses");
var mapMediaInfoToLiveVideoStatus = function (mediaInfo, itemType) {
    var _a, _b;
    var status = (_b = (_a = mediaInfo === null || mediaInfo === void 0 ? void 0 : mediaInfo.fileOutput) === null || _a === void 0 ? void 0 : _a.video[0]) === null || _b === void 0 ? void 0 : _b.status;
    var isLiveVideo = itemType === item_type_1.ItemType.ItemLive;
    return isLiveVideo ? live_statuses_1.LIVE_VIDEO_STATUS[status] : undefined;
};
exports.mapMediaInfoToLiveVideoStatus = mapMediaInfoToLiveVideoStatus;
//# sourceMappingURL=mapMediaInfoToLiveStatus.js.map